import React from 'react';

const Title = ({ company }) => {
  return (
    <div style={{ width: 'auto' }}>
      <div style={{ whiteSpace: 'nowrap' }}>
        Использовать для исходящего вызова номер{' '}
        <strong>{`${company?.shortName || ''} ${
          company?.phone || ''
        },`}</strong>
      </div>
      <div>на который в последний раз звонил собственник?</div>
    </div>
  );
};

export default Title;
